import React from 'react';
import { IReport } from '../models/General';

export default function DashboardTable(list:any) {

    const data:IReport[] = list.data;

    const renderReport = () => {
        return data.map((item, index) => {
          return (
            <React.Fragment>
                <tr key={index}>
                    <td>{index + 1}</td>
                    <td className="rowcustome">{item.PROGRAM}</td>
                    <td className="rowcolorwl1">{item.TOTAL_WL1}</td>
                    <td className="rowcolorwl1">{item.BIA_APPROVED_WL1}</td>
                    <td className="rowcolorwl1">{item.PROGRAM_APPROVED_WL1}</td>
                    <td className="rowcolorwl2">{item.TOTAL_WL2}</td>
                    <td className="rowcolorwl2">{item.BIA_APPROVED_WL2}</td>
                    <td className="rowcolorwl2">{item.PROGRAM_APPROVED_WL2}</td>
                    <td className="rowcolorwl3">{item.TOTAL_WL3}</td>
                    <td className="rowcolorwl3">{item.BIA_APPROVED_WL3}</td>
                    <td className="rowcolorwl3">{item.PROGRAM_APPROVED_WL3}</td>
                    <td className="rowcolorwl3">{item.PROGRAM_REJECTED_WL3}</td>
                    <td className="rowcolorwl3">{item.RECTOR_APPROVED_WL3}</td>
                    <td className="rowcolorwl3">{item.RECTOR_REJECTED_WL3}</td>
                </tr>
            </React.Fragment>
            );
        })
    }

    return (
        <React.Fragment>
            <div className="card-header">
                <h3 className="card-title"></h3>
            </div>
            <div className="card-body table-responsive p-0 tablecustome" >
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th className="rowReport" rowSpan={2}>#</th>
                            <th className="rowReport" rowSpan={2}>Program</th>
                            <th className="rowReport rowcolorwl1" colSpan={3}>Warning Letter 1</th>
                            <th className="rowReport rowcolorwl2" colSpan={3}>Warning Letter 2</th>
                            <th className="rowReport rowcolorwl3" colSpan={6}>Warning Letter 3</th>
                        </tr>
                        <tr>
                            <th className="rowcolorwl1">Total</th>
                            <th className="rowcolorwl1">Approve BIA</th>
                            <th className="rowcolorwl1">Approve Head of Study Program</th>
                            <th className="rowcolorwl2">Total</th>
                            <th className="rowcolorwl2">Approve BIA</th>
                            <th className="rowcolorwl2">Approve Head of Study Program</th>
                            <th className="rowcolorwl3">Total</th>
                            <th className="rowcolorwl3">Approve BIA</th>
                            <th className="rowcolorwl3">Approve Head of Study Program</th>
                            <th className="rowcolorwl3">Reject Head of Study Program</th>
                            <th className="rowcolorwl3">Approve Vice Rector 1</th>
                            <th className="rowcolorwl3">Reject Vice Rector 1</th>
                        </tr>
                    </thead>
                    <tbody>
                        { renderReport()}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
   )

}